var _path, _path2, _circle, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeaching(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7 3.66668V13.6667C7 15.5076 8.49238 17 10.3333 17H30.3333C32.1743 17 33.6667 15.5076 33.6667 13.6667V3.66668C33.6667 1.82573 32.1743 0.333344 30.3333 0.333344H10.3333C8.49238 0.333344 7 1.82573 7 3.66668Z",
    fill: "#0E308E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.045 10.9724C26.6126 11.3653 26.7542 12.144 26.3612 12.7116L18.1497 22.906L16.0942 21.483L24.3057 11.2886C24.6987 10.721 25.4774 10.5794 26.045 10.9724Z",
    fill: "#0E308E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.33333,
    cy: 12,
    r: 3.33333,
    fill: "#0E308E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 22V22.8333L15.7382 20.0001C16.8864 19.2694 18.4111 19.6293 19.1113 20.7963C19.7899 21.9273 19.4375 23.3933 18.3191 24.0924L11.6073 27.6622C11.2059 27.9131 10.7725 28.0679 10.3335 28.1333V32.6667C10.3335 33.219 9.88578 33.6667 9.3335 33.6667H1.3335C0.781211 33.6667 0.333496 33.219 0.333496 32.6667V22C0.333496 19.2386 2.57207 17 5.3335 17C8.09492 17 10.3335 19.2386 10.3335 22Z",
    fill: "#0E308E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.417 7C12.417 6.30964 12.9766 5.75 13.667 5.75L27.0003 5.75C27.6907 5.75 28.2503 6.30964 28.2503 7C28.2503 7.69036 27.6907 8.25 27.0003 8.25L13.667 8.25C12.9766 8.25 12.417 7.69036 12.417 7Z",
    fill: "#0E308E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.417 12C12.417 11.3096 12.9766 10.75 13.667 10.75L20.3337 10.75C21.024 10.75 21.5837 11.3096 21.5837 12C21.5837 12.6904 21.024 13.25 20.3337 13.25L13.667 13.25C12.9766 13.25 12.417 12.6904 12.417 12Z",
    fill: "#0E308E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeaching);
export default __webpack_public_path__ + "static/media/teaching.12d8517f58416ed84525ddd6c4ee727c.svg";
export { ForwardRef as ReactComponent };